import { useMemo } from 'react';
import { useTranslations } from '@lang';

export const useBookingFormLabels = (language: string) => {
  const { t } = useTranslations();

  const counter = useMemo(
    () => ({
      decrease: t('spa.booking.counter.decrease'),
      increase: t('spa.booking.counter.increase'),
    }),
    [t]
  );

  const reservation = useMemo(
    () => ({
      title: t('spa.booking.reservation.title'),
      subtitle: t('spa.booking.reservation.subtitle'),
      guestLabel: t('spa.booking.reservation.guestLabel'),
    }),
    [t]
  );

  const calendar = useMemo(
    () => ({
      previousWeek: t('spa.booking.calendar.previousWeek'),
      nextWeek: t('spa.booking.calendar.nextWeek'),
      openCalendar: t('spa.booking.calendar.openCalendar'),
    }),
    [t]
  );

  const timeslotChips = useMemo(
    () => ({
      title: t('spa.booking.timeslots.title'),
      previousPage: t('spa.booking.timeslots.previous'),
      nextPage: t('spa.booking.timeslots.next'),
      locale: language,
    }),
    [t, language]
  );

  const guestDetails = useMemo(
    () => ({
      subtitle: t('spa.booking.guestDetails.subtitle'),
      dividerText: t('spa.booking.guestDetails.divider'),
      titlePlaceholder: t('spa.booking.guestDetails.selectPlaceholder'),
      titleLabel: t('common.title'),
      firstNameLabel: t('common.firstName'),
      lastNameLabel: t('common.lastName'),
      genderLabel: t('common.gender'),
      guestTitleFormatter: (n: number) => t('spa.guestCounter', { counter: n }),
    }),
    [t]
  );

  const preferences = useMemo(
    () => ({
      title: t('spa.booking.preferences.title'),
      otherButtonLabel: t('spa.booking.preferences.otherButton'),
    }),
    [t]
  );

  const stickyFooterTotalLabel = t('basket.total');

  return {
    counter,
    reservation,
    calendar,
    timeslotChips,
    guestDetails,
    preferences,
    stickyFooterTotalLabel,
  };
};
